export default "__VITE_ASSET__B$bieKHT__"